import { useState } from 'react';
import { DateRangeFilter } from '@/components/filters/DateRangeFilter';

/**
 * Convert a Date instance to a local YYYY-MM-DD string.
 * Using toISOString() would shift by the UTC offset — e.g. a Date representing
 * 2026-04-01 00:00 local time in +03:00 becomes 2026-03-31T21:00Z, so
 * toISOString().slice(0,10) returns "2026-03-31" which is the wrong day.
 * Building the string from local getters avoids that off-by-one.
 */
function toLocalIsoDate(d) {
  if (!d) return null;
  if (typeof d === 'string') return d.slice(0, 10);
  if (!(d instanceof Date) || isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * iter881 — Legacy DateFilter API preserved but rendered via the new
 * <DateRangeFilter> preset-popover. Emits the same `{start, end, start_date,
 * end_date, start_obj, end_obj, period}` shape that every existing caller
 * expects, so all 20+ pages using this component instantly get the modern
 * preset-driven UI without any per-page rewrites.
 */
export function DateFilter({ onFilterChange }) {
  const [range, setRange] = useState({ start_date: null, end_date: null });

  const emit = (r) => {
    setRange(r);
    const startObj = r.start_date ? new Date(r.start_date) : null;
    const endObj = r.end_date ? new Date(r.end_date + 'T23:59:59') : null;
    onFilterChange({
      start: toLocalIsoDate(startObj),
      end: toLocalIsoDate(endObj),
      start_date: r.start_date || null,
      end_date: r.end_date || null,
      start_obj: startObj,
      end_obj: endObj,
      period: r.start_date && r.end_date ? 'custom' : 'all',
    });
  };

  return (
    <div className="flex gap-3 items-end flex-wrap" data-testid="date-filter">
      <DateRangeFilter value={range} onChange={emit} testid="date-filter" />
    </div>
  );
}

export default DateFilter;
